<script setup lang="ts">
const gameStateStore = useGameStateStore()
</script>

<template>
  <!-- <v-app id="app"> -->
  <div
    id="main"
    class="bg-grey-lighten-3 h-screen"
  >
    <div id="main-content">
      <NuxtPage />

      <AppVersion />

      <!-- Snackbar queue for default-layout pages (admin tools, etc.) #623.
           notificationQueue は共有キューでログインボーナス等の通常通知も流れてくるため、
           表示は centering43 と揃える: color=info / variant=flat / location=left center
           / v-slide-x-transition (#630)。Acting block 403 を視覚的に区別したい場合は
           notificationQueue を {message, level} 型化するか専用 errorQueue を分けて
           対応する。
           contained は付けない: default レイアウトには 4:3 の含み枠 (position: relative)
           の親が無いためビューポート左端 / 上下中央に出す。 -->
      <v-snackbar-queue
        v-if="gameStateStore.notificationQueue"
        v-model="gameStateStore.notificationQueue"
        location="left center"
        color="info"
        variant="flat"
        transition="v-slide-x-transition"
        :timeout="5000"
      />
    </div>
  </div>
  <!-- </v-app> -->
</template>

<style scoped>
#main {
  background-image: url("@/assets/images/SIZEN17A_33x30a.webp");
  background-position: top center;
  background-repeat: repeat;

  height: 100%;
}

#main #main-content {
  width: 100%;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;

  height: 100%;

  padding: 0 16px;
}
</style>
